import { useRef } from 'react';

import { CloseIcon, IconButton, SearchIcon } from '@thefarmersfront/kitchen';

import { useGetSmartSearch } from '~/hooks/smart-search';
import { useSmartSearchStore } from '~/store/common';

import styles from './SmartSearchInput.module.scss';

const SmartSearchInput = () => {
  const inputRef = useRef<HTMLInputElement>(null);
  const inputValue = useSmartSearchStore((state) => state.inputValue);
  const submittedQuery = useSmartSearchStore((state) => state.submittedQuery);
  const { setInputValue, submitSearch } = useSmartSearchStore((state) => state.actions);

  const { isLoading } = useGetSmartSearch(submittedQuery);

  const handleSubmit = () => {
    if (isLoading) return;
    const trimmed = inputValue.trim();
    if (!trimmed) return;
    submitSearch(trimmed);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSubmit();
    }
  };

  const handleClear = () => {
    setInputValue('');
    inputRef.current?.focus();
  };

  return (
    <div className={styles['search-bar-wrapper']}>
      <div className={styles['search-bar']}>
        <div className={styles['icon-wrap']}>
          <SearchIcon size={24} color="gray400" />
        </div>
        <input
          ref={inputRef}
          className={styles['search-input']}
          type="text"
          placeholder="궁금한 내용을 입력해 주세요"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={isLoading}
        />
        {inputValue && !isLoading && (
          <div className={styles['icon-wrap']}>
            <IconButton icon={<CloseIcon size={20} color="gray400" />} onClick={handleClear} />
          </div>
        )}
      </div>
    </div>
  );
};

export default SmartSearchInput;
